type RuntimeEnv = Record<string, any>;

export const resolveRuntimeEnv = (
    viteEnv: RuntimeEnv | null | undefined,
    processEnv: RuntimeEnv | null | undefined,
) => {
    if (viteEnv != null) {
        return viteEnv;
    }

    return processEnv ?? {};
};
